/*******************************************************************************
 * File: LoggedInAccountHeader.js
 * Summary: Component for account display on header
 ******************************************************************************/

/*******************************************************************************
 * Section: Imports
 ******************************************************************************/
import iconAvatar from '../../assets/icon/avatar.svg'
import { IconAvatar } from '../../styled/CommonStylesForms'

import styled from 'styled-components'

/*******************************************************************************
 * Section: Custom Divs
 ******************************************************************************/
const Account = styled.div`
  float: left;
  margin-right: 13px;
  color: white;
`

/*******************************************************************************
 * Function: LoggedInAccountHeader:
 * Summary: Displays an icon along with the users name beside the users icon
 * @param {object} props - userData, userData.given_names, userData.family_names
 ******************************************************************************/
function LoggedInAccountHeader(props) {
  // Name builder
  let displayText = ''

  if (props.userData && props.userData.given_names) {
    displayText += props.userData.given_names
  }
  if (props.userData && props.userData.family_names) {
    displayText += ' ' + props.userData.family_names
  }

  return (
    <Account>
      <IconAvatar src={iconAvatar} alt="Account" /> {displayText} ▾
    </Account>
  )
}

export default LoggedInAccountHeader
